import React, { useEffect } from "react";

import type { TBanner } from "~/slices/banners";

export function Banners({ banners, mobile }: { banners: TBanner[]; mobile?: boolean }) {
  useEffect(() => {
    if (mobile) {
      $("#carousel").carousel();
    }
  }, [mobile]);

  const path = window.location.pathname;

  if (banners.length != 0 && mobile) {
    return (
      <div
        id="carousel"
        className="carousel slide"
        data-ride="carousel"
        data-interval={4000}
        data-testid="carousel"
      >
        <div className="carousel-inner" role="listbox">
          {banners.map((banner, i) => (
            <div key={i} className={i == 0 ? `item active` : "item"}>
              {banner.type == "empty" ? (
                <BannerImage
                  image={banner.icon_url}
                  altText={banner.description ?? ""}
                  data-track-content
                  data-content-name="banners"
                />
              ) : (
                <Banner
                  path={banner.link || banner.banner_url || ""}
                  image={banner.icon_url}
                  altText={banner.description ?? ""}
                  data-track-content
                  data-content-name="banners"
                />
              )}
            </div>
          ))}

          <a
            className="left carousel-control"
            href="#carousel"
            data-slide="prev"
            role="button"
            style={{ background: "transparent" }}
          >
            <span
              className="glyphicon glyphicon-chevron-left"
              aria-hidden="true"
              style={{ marginLeft: "-26px", fontSize: "28px" }}
            ></span>
          </a>
          <a
            className="right carousel-control"
            href="#carousel"
            data-slide="next"
            role="button"
            style={{ background: "transparent" }}
          >
            <span
              className="glyphicon glyphicon-chevron-right"
              aria-hidden="true"
              style={{ marginRight: "-26px", fontSize: "28px" }}
            ></span>
          </a>
        </div>
      </div>
    );
  }

  return (
    <div>
      {banners.map((banner, i) => {
        if (path != "/pages/home") {
          return (
            <div
              data-testid="left_sidebar_banners"
              data-track-content
              data-content-name="banners"
              key={i}
              style={{
                background: "#e9edf4",
                marginLeft: -16,
                marginRight: -16,
                paddingTop: "16px",
              }}
            >
              {banner.type == "empty" ? (
                <BannerImage
                  image={banner.icon_url}
                  altText={banner.description ?? ""}
                  data-track-content
                  data-content-name="banners"
                />
              ) : (
                <Banner
                  path={banner.link || banner.banner_url || ""}
                  image={banner.icon_url}
                  altText={banner.description ?? ""}
                  data-track-content
                  data-content-name="banners"
                />
              )}
            </div>
          );
        }
      })}
    </div>
  );
}

export function Banner({ path, image, altText }: { path: string; image: string; altText: string }) {
  return (
    <div data-testid="banner_link">
      <div style={{ marginLeft: 1, marginRight: 1 }}>
        <a href={path} rel="noopener noreferrer" target="_blank">
          <div style={{ width: "100%", backgroundColor: "#3b8489" }}>
            <img src={image} width="100%" style={{ width: "100%" }} alt="" /* alt={altText} */ />
          </div>
        </a>
      </div>
    </div>
  );
}

export function BannerImage({ image, altText }: { image: string; altText: string }) {
  return (
    <div
      style={{ background: "#e9edf4", marginLeft: 1, marginRight: 1 }}
      data-testid="banner_image"
    >
      <div style={{ marginLeft: 1, marginRight: 1 }}>
        <div style={{ width: "100%", backgroundColor: "#3b8489" }}>
          <img src={image} width="100%" style={{ width: "100%" }} alt="" /* alt={altText} */ />
        </div>
      </div>
    </div>
  );
}
